<mat-radio-group [value]="value" aria-label="Select an option">
  <mat-radio-button
    color="primary"
    class="pr-4 font-light"
    *ngFor="let option of options"
    [value]="option.id"
    (change)="onChange($event)"
    >{{ option.label }}</mat-radio-button
  >
</mat-radio-group>
